import { render, staticRenderFns } from "./ProgressSteps.vue?vue&type=template&id=71587f4c&"
import script from "./ProgressSteps.vue?vue&type=script&lang=js&"
export * from "./ProgressSteps.vue?vue&type=script&lang=js&"
import style0 from "./ProgressSteps.vue?vue&type=style&index=0&id=71587f4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports